import type { RichMenuTemplate } from "../types/richmenu.types";

// Extended template interface with image URL
export interface RichMenuTemplateWithImage extends RichMenuTemplate {
	imageUrl?: string;
}

/**
 * Rich menu template constants
 */
export const RICHMENU_TEMPLATES_COMPACT: Record<string, RichMenuTemplate> = {
	RICH_MENU_TEMPLATE_101: {
		name: "RICH_MENU_TEMPLATE_101",
		size: { width: 1200, height: 405 },
		areas: [
			{
				bounds: { x: 0, y: 0, width: 400, height: 405 },
				action: { type: "message", text: "Action 1" },
			},
			{
				bounds: { x: 400, y: 0, width: 400, height: 405 },
				action: { type: "message", text: "Action 2" },
			},
			{
				bounds: { x: 800, y: 0, width: 400, height: 405 },
				action: { type: "message", text: "Action 3" },
			},
		],
	},
	RICH_MENU_TEMPLATE_102: {
		name: "RICH_MENU_TEMPLATE_102",
		size: { width: 1200, height: 405 },
		areas: [
			{
				bounds: { x: 0, y: 0, width: 600, height: 405 },
				action: { type: "message", text: "Action 1" },
			},
			{
				bounds: { x: 600, y: 0, width: 600, height: 405 },
				action: { type: "message", text: "Action 2" },
			},
		],
	},
	RICH_MENU_TEMPLATE_103: {
		name: "RICH_MENU_TEMPLATE_103",
		size: { width: 1200, height: 405 },
		areas: [
			{
				bounds: { x: 0, y: 0, width: 800, height: 405 },
				action: { type: "message", text: "Action 1" },
			},
			{
				bounds: { x: 800, y: 0, width: 400, height: 405 },
				action: { type: "message", text: "Action 2" },
			},
		],
	},
	RICH_MENU_TEMPLATE_104: {
		name: "RICH_MENU_TEMPLATE_104",
		size: { width: 1200, height: 405 },
		areas: [
			{
				bounds: { x: 0, y: 0, width: 400, height: 405 },
				action: { type: "message", text: "Action 1" },
			},
			{
				bounds: { x: 400, y: 0, width: 800, height: 405 },
				action: { type: "message", text: "Action 2" },
			},
		],
	},
	RICH_MENU_TEMPLATE_105: {
		name: "RICH_MENU_TEMPLATE_105",
		size: { width: 1200, height: 405 },
		areas: [
			{
				bounds: { x: 0, y: 0, width: 1200, height: 405 },
				action: { type: "message", text: "Action 1" },
			},
		],
	},
};

export const RICHMENU_TEMPLATES_LARGE: Record<string, RichMenuTemplate> = {
	RICH_MENU_TEMPLATE_201: {
		name: "RICH_MENU_TEMPLATE_201",
		size: { width: 1200, height: 810 },
		areas: [
			{
				bounds: { x: 0, y: 0, width: 400, height: 405 },
				action: { type: "message", text: "Action 1" },
			},
			{
				bounds: { x: 400, y: 0, width: 400, height: 405 },
				action: { type: "message", text: "Action 2" },
			},
			{
				bounds: { x: 800, y: 0, width: 400, height: 405 },
				action: { type: "message", text: "Action 3" },
			},
			{
				bounds: { x: 0, y: 405, width: 400, height: 405 },
				action: { type: "message", text: "Action 4" },
			},
			{
				bounds: { x: 400, y: 405, width: 400, height: 405 },
				action: { type: "message", text: "Action 5" },
			},
			{
				bounds: { x: 800, y: 405, width: 400, height: 405 },
				action: { type: "message", text: "Action 6" },
			},
		],
	},
	RICH_MENU_TEMPLATE_202: {
		name: "RICH_MENU_TEMPLATE_202",
		size: { width: 1200, height: 810 },
		areas: [
			{
				bounds: { x: 0, y: 0, width: 600, height: 405 },
				action: { type: "message", text: "Action 1" },
			},
			{
				bounds: { x: 600, y: 0, width: 600, height: 405 },
				action: { type: "message", text: "Action 2" },
			},
			{
				bounds: { x: 0, y: 405, width: 600, height: 405 },
				action: { type: "message", text: "Action 3" },
			},
			{
				bounds: { x: 600, y: 405, width: 600, height: 405 },
				action: { type: "message", text: "Action 4" },
			},
		],
	},
	RICH_MENU_TEMPLATE_203: {
		name: "RICH_MENU_TEMPLATE_203",
		size: { width: 1200, height: 810 },
		areas: [
			{
				bounds: { x: 0, y: 0, width: 1200, height: 405 },
				action: { type: "message", text: "Action 1" },
			},
			{
				bounds: { x: 0, y: 405, width: 400, height: 405 },
				action: { type: "message", text: "Action 2" },
			},
			{
				bounds: { x: 400, y: 405, width: 400, height: 405 },
				action: { type: "message", text: "Action 3" },
			},
			{
				bounds: { x: 800, y: 405, width: 400, height: 405 },
				action: { type: "message", text: "Action 4" },
			},
		],
	},
	RICH_MENU_TEMPLATE_204: {
		name: "RICH_MENU_TEMPLATE_204",
		size: { width: 1200, height: 810 },
		areas: [
			{
				bounds: { x: 0, y: 0, width: 800, height: 810 },
				action: { type: "message", text: "Action 1" },
			},
			{
				bounds: { x: 800, y: 0, width: 400, height: 405 },
				action: { type: "message", text: "Action 2" },
			},
			{
				bounds: { x: 800, y: 405, width: 400, height: 405 },
				action: { type: "message", text: "Action 3" },
			},
		],
	},
	RICH_MENU_TEMPLATE_205: {
		name: "RICH_MENU_TEMPLATE_205",
		size: { width: 1200, height: 810 },
		areas: [
			{
				bounds: { x: 0, y: 0, width: 1200, height: 405 },
				action: { type: "message", text: "Action 1" },
			},
			{
				bounds: { x: 0, y: 405, width: 1200, height: 405 },
				action: { type: "message", text: "Action 2" },
			},
		],
	},
	RICH_MENU_TEMPLATE_206: {
		name: "RICH_MENU_TEMPLATE_206",
		size: { width: 1200, height: 810 },
		areas: [
			{
				bounds: { x: 0, y: 0, width: 600, height: 810 },
				action: { type: "message", text: "Action 1" },
			},
			{
				bounds: { x: 600, y: 0, width: 600, height: 810 },
				action: { type: "message", text: "Action 2" },
			},
		],
	},
	RICH_MENU_TEMPLATE_207: {
		name: "RICH_MENU_TEMPLATE_207",
		size: { width: 1200, height: 810 },
		areas: [
			{
				bounds: { x: 0, y: 0, width: 1200, height: 810 },
				action: { type: "message", text: "Action 1" },
			},
		],
	},
	RICH_MENU_CUSTOM_TEMPLATE_201: {
		name: "RICH_MENU_CUSTOM_TEMPLATE_201",
		size: { width: 1200, height: 810 },
		areas: [
			{
				bounds: { x: 0, y: 200, width: 400, height: 305 },
				action: { type: "message", text: "Action 1" },
			},
			{
				bounds: { x: 400, y: 200, width: 400, height: 305 },
				action: { type: "message", text: "Action 2" },
			},
			{
				bounds: { x: 800, y: 200, width: 400, height: 305 },
				action: { type: "message", text: "Action 3" },
			},
			{
				bounds: { x: 0, y: 505, width: 400, height: 305 },
				action: { type: "message", text: "Action 4" },
			},
			{
				bounds: { x: 400, y: 505, width: 400, height: 305 },
				action: { type: "message", text: "Action 5" },
			},
			{
				bounds: { x: 800, y: 505, width: 400, height: 305 },
				action: { type: "message", text: "Action 6" },
			},
		],
	},
	RICH_MENU_CUSTOM_TEMPLATE_202: {
		name: "RICH_MENU_CUSTOM_TEMPLATE_202",
		size: { width: 1200, height: 810 },
		areas: [
			{
				bounds: { x: 0, y: 110, width: 600, height: 350 },
				action: { type: "message", text: "Action 1" },
			},
			{
				bounds: { x: 600, y: 110, width: 600, height: 350 },
				action: { type: "message", text: "Action 2" },
			},
			{
				bounds: { x: 0, y: 460, width: 600, height: 350 },
				action: { type: "message", text: "Action 3" },
			},
			{
				bounds: { x: 600, y: 460, width: 600, height: 350 },
				action: { type: "message", text: "Action 4" },
			},
		],
	},
};

export const RICHMENU_IMAGE_REQUIREMENTS = {
	MIN_WIDTH: 800,
	MAX_WIDTH: 2500,
	MIN_HEIGHT: 250,
	COMPACT_HEIGHT: 843,
	LARGE_HEIGHT: 1686,
	SUPPORTED_FORMATS: ["image/jpeg", "image/png"],
	MAX_FILE_SIZE: 1024 * 1024, // 1MB
} as const;

export const RICHMENU_ACTION_TYPES = {
	MESSAGE: "message",
	URI: "uri",
	SWITCH: "richmenuswitch",
} as const;

export const RICHMENU_TAB_GROUP_STATUS = {
	DRAFT: "DRAFT",
	PUBLISHED: "PUBLISHED",
} as const;

export const RICHMENU_DISPLAY_PRIORITY = {
	USER: "USER",
	DEFAULT: "DEFAULT",
} as const;

// Utility function to filter out richmenuswitch areas for UI display
export const filterRichmenuSwitchAreas = (areas: any[]) => {
	if (!Array.isArray(areas)) return [];
	return areas.filter((area) => area.action?.type !== "richmenuswitch");
};

// Utility function to get richmenu data with filtered areas for UI
export const getRichmenuForUI = (richmenu: any) => {
	if (!richmenu) return null;
	return {
		...richmenu,
		areas: filterRichmenuSwitchAreas(richmenu.areas || []),
	};
};

// Utility function to get tab group data with filtered areas for UI
export const getTabGroupForUI = (tabGroup: any) => {
	if (!tabGroup) return null;
	return {
		...tabGroup,
		richmenus: tabGroup.richmenus?.map((rm: any) => getRichmenuForUI(rm)) || [],
	};
};
